import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import queryString from 'query-string';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { openOrderWindow } from '../../store/actions/orders';
import { getEffectiveOrderPayload } from '../../services/utilities/orderUtils';
// import { getEffectiveOrderPayload } from '../../services/utilities/orderUtils';

const ChartIframe = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 'none',
  margin: 'auto'
});

const Charts = ({ exchange, token, theme, pricePrecision, scripInfo }) => {
  const themeMode = theme.palette.mode;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentTheme, setCurrentTheme] = useState(themeMode);
  const dispatch = useDispatch();
  const { userSettings } = useSelector((state) => state.profile);
  const positionsArray = useSelector((state) => state.portfolio?.arrPositionsUpdateData || []);

  const handleOrder = (side) => {
    const localInstrument = {
      exchange,
      token,
      ltp: scripInfo?.ltp || 0,
      trading_symbol: scripInfo?.trading_symbol || "",
      display_name: scripInfo?.display_name || "",
      instrument_name: scripInfo?.instrument_name || ""
    };

    dispatch(openOrderWindow(
      getEffectiveOrderPayload(localInstrument, side, userSettings, positionsArray)
    ));
  };



  // Force update when theme changes
  useEffect(() => {
    if (currentTheme !== themeMode) {
      setCurrentTheme(themeMode);
    }
  }, [themeMode, currentTheme]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'TV_OPEN_ORDER_WINDOW') {
        const { price, side } = event.data.payload;

        const localInstrument = {
          exchange,
          token,
          ltp: price
        };

        dispatch(openOrderWindow(
          getEffectiveOrderPayload(localInstrument, side, userSettings, positionsArray)
        ));
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [dispatch, exchange, token, userSettings, positionsArray]);

  const isIndex = scripInfo?.is_index;

  const chartParams = {
    exchange,
    token,
    login_id: localStorage.getItem('login_id'),
    web: true,
    login_token: localStorage.getItem('auth_token'),
    exchanges_subscribed: "NSE,BSE,NFO,MCX,CDS,BFO,DCSX",
    theme: currentTheme,
    color: theme.palette.background.paper,
    precision: pricePrecision,
    index: isIndex
  };

  const qs = queryString.stringify(chartParams);
  const chartUrl = `/newcharts/?${qs}`;


  if (!chartUrl) return null;

  return (
    <Box
      sx={{
        width: '100%',
        height: '99%',
        p: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ flexGrow: 1, width: '100%', height: (isMobile && !isIndex) ? 'calc(100% - 60px)' : '100%' }}>
        <ChartIframe
          key={`chart-iframe-${currentTheme}`}
          src={chartUrl}
          title="TradingView Chart"
        />
      </Box>

      {isMobile && !isIndex && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            p: 1.5,
            bgcolor: 'background.paper',
            borderTop: 1,
            borderColor: 'divider',
            height: '60px'
          }}
        >
          <Button
            variant="contained"
            fullWidth
            color="success"
            onClick={() => handleOrder('BUY')}
            sx={{
              bgcolor: (theme) => theme.palette.success.main,
              '&:hover': { bgcolor: (theme) => theme.palette.success.dark },
              fontWeight: 600
            }}
          >
            BUY
          </Button>
          <Button
            variant="contained"
            fullWidth
            color="error"
            onClick={() => handleOrder('SELL')}
            sx={{
              bgcolor: (theme) => theme.palette.error.main,
              '&:hover': { bgcolor: (theme) => theme.palette.error.dark },
              fontWeight: 600
            }}
          >
            SELL
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default Charts; 